import React, { useContext, useEffect, useState } from "react";
import axios from "axios";
import { getManager } from "../../api/managerApi";
import { AuthContext } from "../../context/AuthContext";
import { MENU_CONFIG } from "../manager/items/SideMenuList";
import MailSlackList from "./MailSlackList";

const FALLBACK_MAIL_CONFIG = MENU_CONFIG.menusByKey.mail;

function toMailHost(value) {
  return String(value || '').trim().replace(/^https?:\/\//i, '').replace(/\/.*$/, '');
}

function buildSogoUrl(mailDomain, userid, folder = 'INBOX') {
  const mailDomainRaw = String(mailDomain || '').trim();
  const base = /^https?:\/\//i.test(mailDomainRaw) ? mailDomainRaw : `https://${mailDomainRaw}`;
  const mailHost = toMailHost(mailDomainRaw);
  if (!base || !mailHost || !userid) return '';
  return `${base}/SOGo/so/${userid}@${mailHost}/Mail/0/folder${encodeURIComponent(folder)}/view`;
}

function parseSogoMails(sogoData, limit) {
  const emailList = [];

  if (Array.isArray(sogoData?.headers) && sogoData.headers.length > 0) {
    const headerRow = Array.isArray(sogoData.headers[0]) ? sogoData.headers[0] : [];
    const rows = sogoData.headers.slice(1);
    const indexMap = Object.fromEntries(headerRow.map((name, idx) => [name, idx]));

    rows.forEach((row) => {
      if (!Array.isArray(row)) return;

      const uid = row[indexMap.uid];
      const subject = row[indexMap.Subject] || '(제목 없음)';
      const fromRaw = row[indexMap.From];
      const relativeDate = row[indexMap.RelativeDate] || null;
      const isRead = row[indexMap.isRead];

      let from = '';
      if (Array.isArray(fromRaw)) {
        from = fromRaw
          .map((f) => {
            if (f.name && f.email) return `${f.name} <${f.email}>`;
            if (f.email) return f.email;
            return f.name || '';
          })
          .filter(Boolean)
          .join(', ');
      } else if (typeof fromRaw === 'object' && fromRaw !== null) {
        from = fromRaw.name ? `${fromRaw.name} <${fromRaw.email}>` : fromRaw.email;
      } else if (typeof fromRaw === 'string') {
        from = fromRaw;
      }

      emailList.push({
        uid: uid || `row-${emailList.length + 1}`,
        subject,
        from,
        date: relativeDate,
        preview: '',
        seen: Number(isRead) === 1,
      });
    });
  }

  return emailList.slice(0, limit);
}

function RecentMailListCard({title = "최근 메일", limit = 5, ssoReady = false}) {
  const [mails, setMails] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [mailConfig, setMailConfig] = useState(FALLBACK_MAIL_CONFIG);
  const [mailDomain, setMailDomain] = useState("");
  const { user } = useContext(AuthContext);

  useEffect(() => {
    const comCode = sessionStorage.getItem("M_ComCode");
    if (!comCode) return;
    getManager(comCode)
      .then((manager) => {
        const mailDomain = String(manager?.M_MailDomain || '').trim();
        if (!mailDomain) return;
        setMailDomain(mailDomain);
        const base = /^https?:\/\//i.test(mailDomain) ? mailDomain : `https://${mailDomain}`;
        setMailConfig((prev) => ({
          ...prev,
          url: base,
          sessionUrl: `${base}/mailcow_auto_login_enhanced_debug.php`,
        }));
      })
      .catch(err => console.error('회사 메일 도메인 조회 실패:', err));
  }, []);
  useEffect(() => {
    const fetchMailList = async () => {
      try {
        setError(null);
        const sessionValue = sessionStorage.getItem("session");
        const sessionUrl = mailConfig?.sessionUrl ?? mailConfig?.session_url;
        const token = sessionStorage.getItem("token");
        if (sessionValue && sessionValue !== 'null' && sessionUrl) {
          
          const res = await axios.get(`/api/mail/list?limit=${limit}`, {
            headers: { Authorization: `Bearer ${token}` },
          });
          if (!res.data.success) {
            setMails([]);
            return;
          }
          setMails(res.data?.emails || []);
        } else {
          if (!ssoReady) return;
          const sogoUrl = buildSogoUrl(mailDomain, user?.userid);
          if (!sogoUrl) {
            setMails([]);
            setError('메일 도메인 또는 사용자 정보가 없습니다.');
            return;
          }
          const res = await axios.get(sogoUrl, {
            withCredentials: true,
          });
          console.log(sogoUrl);
          console.log(res.data);
          setMails(parseSogoMails(res.data, limit));
        }
      } catch (err) {
        console.error("메일 목록 불러오기 실패:", err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchMailList();
  }, [limit, mailConfig, mailDomain, user?.userid, ssoReady]);

  const handleMoreClick = () => {
    const sessionValue = sessionStorage.getItem("session");
    const sessionUrl = mailConfig?.sessionUrl ?? mailConfig?.session_url;
    const url = mailConfig?.url;
    if (sessionValue && sessionValue !== 'null' && sessionUrl) {
      window.open(`${sessionUrl}?key=${encodeURIComponent(sessionValue)}`, '_blank');
    } else if (url) {
      window.open(url, '_blank');
    }

  };

  const openMail = (mail) => {
    if (!mailDomain || !user?.userid || !mail?.uid) return;
    const sessionValue = sessionStorage.getItem("session");
    const sessionUrl = mailConfig?.sessionUrl ?? mailConfig?.session_url;
    let url = mailConfig?.url;
    if (sessionValue && sessionValue !== 'null' && sessionUrl) {
      url += `/mailcow_auto_login_enhanced_detail.php?key=${encodeURIComponent(sessionValue)}&uid=${mail.uid}`;
    }
    url += `/SOGo/so/${user.userid}@${toMailHost(mailDomain)}/Mail/view#!/Mail/0/INBOX/${mail.uid}`;
    console.log(url);
    window.open(url, "mailView");
  };

  return (
    <MailSlackList
      title={title}
      mails={mails}
      loading={loading}
      error={error}
      limit={limit}
      onMoreClick={handleMoreClick}
      onMailClick={openMail}
    />
  );
}
export default RecentMailListCard;


